import type { DateTimeString, Uuid } from "@/utils"

/**
 * Mirrors backend/src/Notification/NotificationType.php
 */
export enum NotificationType {
  VerifyEmail = "verify_email",
  /** To workspace members: an evaluation they commissioned is published */
  EvaluationPublished = "evaluation_published",
  /** To the evalee: their own evaluation is ready in My Profiles */
  EvaluationReady = "evaluation_ready",
  /** To the payer: a self-profile purchase settled; entityId is the assignment */
  SelfProfileReady = "self_profile_ready",
  /** To the payer: a send-assignments purchase settled and went out */
  AssignmentsSent = "assignments_sent",
  /** To the payer: a top-up purchase settled; credits are on the balance */
  CreditsReady = "credits_ready",
}

export type Notification = {
  readonly id: Uuid
  readonly type: NotificationType
  readonly entityId: Uuid
  /** Server-rendered fallback text, used when the client cannot localise */
  readonly text: string
  /** Type-specific interpolation values for client-side localisation */
  readonly params: Record<string, string> | null
  readonly validAfter: DateTimeString
}

// Flash messages carried an entity link in PromptJuggler, typed to its
// `dataset` concept. Nothing here has an equivalent, and the resolver was
// never written — so the field is dropped rather than left to throw.
// Reinstate with a real resolver if a linkable entity type appears.

export type FlashMessage = {
  variant: "info" | "success" | "warning" | "error"
  message: string
}
